import {Button} from "devextreme-react/button";
import React, {Dispatch, SetStateAction, useEffect, useState} from "react";
import useApi from "../../hooks/useApi";
import LoadIndicator from "devextreme-react/load-indicator";
import DataGrid, {Column, Editing, RowDragging, SearchPanel} from "devextreme-react/data-grid";
import ILookupItem from "../../models/ILookupItem";
import IProduitCategorie from "../../models/IProduitCategorie";
import ICatalogue from "../../models/ICatalogue";

interface IListUniteDisponcibleItemProps {
    produitCategorie: IProduitCategorie
    refresh?: boolean
    setSelectedProduit: Dispatch<SetStateAction<ICatalogue[] | undefined>>
    selectedProduit: ICatalogue[],
    isModeModify?: boolean,
    isReservation?: boolean
}

const ListProduitItem = ({produitCategorie, refresh, selectedProduit, setSelectedProduit, isModeModify, isReservation}: IListUniteDisponcibleItemProps) => {
    const {description, idProduitCategorie} = produitCategorie;
    const [collapsed, setCollapsed] = useState(true)

    const {data: produits, getData: getProduits, isLoading} = useApi<ICatalogue[]>("catalogue")

    useEffect(() => {
        if (collapsed || !idProduitCategorie) return;
        getProduits({customPath: `produitcategorie/${idProduitCategorie}/produits?pourReservation=${isReservation}`})
    }, [collapsed, refresh, idProduitCategorie, isReservation])

    return (
        <div style={{display: "flex", flexDirection: "column"}}>
            <div className={"list-unite-disponible-item"}>
                <div style={{flex: 1}}>{description}<LoadIndicator style={{marginLeft: '0.5rem'}} visible={isLoading} height={13} width={13}/></div>
                <Button icon={collapsed ? "chevrondown" : "chevronup"}
                        onClick={() => {
                            setCollapsed(prev => !prev)
                        }}
                        style={{boxShadow: "none"}}
                />
            </div>
            {!isLoading && !collapsed &&
                <DataGrid id={`listProduit-${idProduitCategorie}`} noDataText={""}
                          dataSource={produits}
                          searchPanel={{visible: (produits?.length || 0) > 10}}>
                    <SearchPanel/>
                    <Editing mode={"cell"} allowUpdating={true} allowAdding={false} allowDeleting={false}/>
                    {isModeModify && <RowDragging showDragIcons={false} group={"ajoutRapid"} onDragStart={(e: any) => {
                        const produit = [...selectedProduit.filter(f => !f.idProduit?.equals(e.itemData.idProduit)), e.itemData]
                        e.itemData = {selectedProduit: produit}
                    }}/>}
                    <Column dataField={"selectionnee"} caption={""} width={"1rem"} dataType={"boolean"}
                            calculateCellValue={(e: ICatalogue) => {
                                return !!selectedProduit.find(f => f.idProduit?.equals(e.idProduit))
                            }}
                            setCellValue={(e: any, value: boolean, currentRowData: ICatalogue) => {
                                setSelectedProduit(prev => {
                                    const produitSanscurrent = prev?.filter(p => !p.idProduit?.equals(currentRowData.idProduit))
                                    return value ? [...prev || [], currentRowData] : [...produitSanscurrent || []];
                                });
                                e = value;
                                return e;
                            }}/>
                    <Column alignment={"center"} allowEditing={false} dataField={"description"}/>
                </DataGrid>}
        </div>
    )
}
export default ListProduitItem